import React, { useState } from "react";
import Alert from "./GxAlert";

/**
 * یادداشتِ فشرده و **قابلِ پاک‌کردن** — روی `GxAlert` سوار است، پس جمع‌شدنِ
 * توضیح پشتِ «بیشتر» را از آن به ارث می‌برد.
 *
 * تنها چیزی که اضافه می‌کند: بستنِ ماندگار.
 *
 * `signature`: امضای وضعیت (مثلاً «ماه + تعدادِ نفراتِ جامانده»). وقتی کاربر
 * می‌بندد فقط **همان وضعیت** بسته می‌ماند؛ اگر ماه عوض شود یا مشکلِ تازه‌ای
 * پیدا شود امضا فرق می‌کند و یادداشت دوباره خودش را نشان می‌دهد. بدونِ این،
 * کاربر یک‌بار می‌بندد و دیگر هیچ‌وقت از خطای بعدی خبردار نمی‌شود.
 */
export default function GxNote({
  id, signature = "", message, children, type = "info", closable = true, style,
}) {
  const key = id ? `gxnote:${id}:${signature}` : null;
  const [hidden, setHidden] = useState(
    () => !!key && globalThis.localStorage?.getItem(key) === "1");

  if (hidden) return null;

  return (
    <Alert
      type={type}
      showIcon
      closable={closable}
      onClose={() => {
        if (key) globalThis.localStorage?.setItem(key, "1");
        setHidden(true);
      }}
      style={{ marginBottom: 10, ...style }}
      message={message}
      description={children}
    />
  );
}
